module.exports = __webpack_public_path__ + "static/img/bg_2.3991fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/bg_2.jpg
// module id = cYWM
// module chunks = 1